export const ENDPOINTS = {
    JOB_ALERT: {
        STORE: '/job-alerts'
    }
}

export const api_error = response => `${response.status}: ${response.data?.message}`

export const format_api_data = formData => {
    const data = new FormData()

    Object.entries(formData)
        .forEach(([key, {value}]) => {
            if (value !== null && value !== '') {
                if (value instanceof Array || value instanceof FileList) {
                    Object.values(value).forEach(arrayValue => {
                        data.append(`${key}[]`, arrayValue)
                    })
                } else {
                    data.append(key, value)
                }
            }
        })

    return data
}